import React from 'react';

import '../assets/css/main.css';

const Intro = (props) => {
    return (
    <div className={props.showModal? "modal-backdrop fade show":"modal fade"} id="headUp" tabIndex="-1" aria-labelledby="headUp" style={{display:props.showModal?'block':'none',opacity:'1',backgroundColor:'#fffc'}}>
        <div className="modal-dialog modal-xl modal-dialog-scrollable modal-fullscreen-sm-down" >
            <div className="modal-content" style={{border:'1px solid black'}}>
                <div className="modal-header">           
                    <button type="button" className="btn-close" onClick={props.closeModal}></button>
                </div>
                <div className="modal-body">
                    <h1>國家電影及視聽文化中心 <br/>藏品檢索系統 使用說明</h1>
                    <div className="info-text">
                        <p><a href='https://docs.google.com/forms/d/e/1FAIpQLScVm6ahjjAwmMD9aAFDKaaWhD1Hzxzcd5rXfO-50BcP7M0cSw/viewform'>平台使用滿意度調查</a></p>
                        <p>國家電影及視聽文化中心歷年來蒐集豐富的電影史料，為妥善保存影視聽史料，建置「藏品檢索系統」，提供各界查詢本中心典藏文物之目錄資訊，以達資源分享與利用目的。本系統提供目前已校對整理完成之目錄資訊約1萬筆，後續將因應藏品著作權利取得、蒐藏及編目進度逐步擴增。數位典藏時期(2007-2010)建置典藏檢索網站待與本系統資料整合完成前仍繼續開放使用。</p>
                        <p>本目錄系統以提供目錄資訊為主，包含電影膠片，電影衍生文物如海報類、器物類、影片數位檔案等。<span style={{fontWeight:'bolder',color:'black',display:'unset',fontSize:'unset',marginTop:'unset'}}>數位化圖檔因須與著作權利所有人洽談授權，目前僅提供新聞片數位檔案與器物類作為瀏覽。</span>藏品能否租借，本中心需視藏品狀態、有無權限等因素而評估，若需取用請填寫<a href='https://www.tfai.org.tw/downloads/rent'>資料借出使用申請單</a>，向本中心提出申請。</p>
                        <p>各類藏品之目錄著錄原則，以文物上的原始資訊為主，將以 [ ] 標示修正後資訊或別名。</p>
                        <p>
                            <span>1 膠片類</span>
                            膠片類一部電影作品，若有聲片、底片、字片、拷貝片、預告片等5套膠片，則系統內顯示5筆資料。聲片、底片因實體物件上並無導演、演職員表相關資料，該筆資訊並未呈現上述資料。
                            <span>2 新聞片</span>
                            一則新聞影片為1筆資料。
                            <span>3 海報類文物</span>
                            一部電影作品若有3種不同版本的海報，則系統內顯示3筆資料。
                            <span>4 器物類文物</span>
                            一部器物為1筆資料。
                            <span>5 數位修復影片</span>
                            一部數位修復電影作品顯示1筆資料。
                        </p>
                    </div>
                </div>
                <div className={'closeButton'}>           
                    <div onClick={props.closeModal}>{"關閉說明"}</div>
                </div>
            </div>
        </div>
    </div>
    )
};

export default Intro;